import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import ApartmentsModal from '../Sections/ApartmentsModal';
import useFilter from '../../../hooks/useFilter';
import ApartmentFilterCard from './ApartmentFilterCard';
import Button from '../../Button';

const ApartmentsFilter = ({
  filterCardList = [],
  defaultFilter = 'all',
  apartmentRooms,
  description
}) => {
  const {
    currentFilter,
    filteredList,
    filterValues,
    filterValuesTranslations,
    buttonClickHandler
  } = useFilter(defaultFilter, filterCardList, apartmentRooms);
  const { t } = useTranslation();
  const ref = useRef(null);
  const [showMore, setShowMore] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [apartment, setApartment] = useState(null);

  const classes = index =>
    cn('ap-filter__container', { hidden: showMore && index > 3 });

  const buttonList = () =>
    filterValuesTranslations?.map((item, i) => (
      <Button
        key={i}
        stat="residence-filter"
        additionalClass={cn('ap-filter__header-btn', {
          active: filterValues[i] === currentFilter
        })}
        onClickHandler={() => {
          buttonClickHandler(filterValues[i], ref);
          setShowMore(true);
        }}
      >
        {item}
      </Button>
    ));

  const contentList = filteredList?.map((item, index) => (
    <div key={item.id} className={classes(index)}>
      <ApartmentFilterCard
        {...{ item }}
        setModal={setOpenModal}
        setApartment={setApartment}
        imgDescription={description}
      />
      {index === 3 && (
        <div
          key={index}
          className={cn('ap-filter__content-btn', {
            hidden: !showMore
          })}
          onClick={() => setShowMore(false)}
          onKeyPress={() => setShowMore(false)}
          role="button"
          tabIndex="0"
        >
          {t('residences.show_more')}
        </div>
      )}
    </div>
  ));

  useEffect(() => {
    const header = document.getElementById('ap-filter__header');
    if (header) {
      const headerContainer = header.parentElement;

      headerContainer.style.height = `${header?.clientHeight}px`;
    }
  }, []);

  return (
    <>
      <div className="ap-filter" id="ap-filter">
        <div className="ap-filter__header-container" ref={ref}>
          <div className="ap-filter__header" id="ap-filter__header">
            <div className="ap-filter__title">
              {t('residences.apartments_title')}
            </div>
            <div className="ap-filter__header-row">{buttonList(ref)}</div>
          </div>
        </div>
        <div>{contentList}</div>
      </div>
      {openModal && (
        <ApartmentsModal
          isOpen={openModal}
          hide={() => setOpenModal(false)}
          apartment={apartment}
          imgDescription={description}
        />
      )}
    </>
  );
};

ApartmentsFilter.displayName = 'ApartmentsFilter';

ApartmentsFilter.propTypes = {
  filterCardList: PropTypes.array.isRequired,
  defaultFilter: PropTypes.string,
  description: PropTypes.string,
  apartmentRooms: PropTypes.array
};

export default ApartmentsFilter;
